<template>
  <div class="recharge_order">
    <!--充值工单列表头部-->
    <div class="recharge_order_top">
      <div class="w_percent15">
        <input type="text" title="工单号/交易流水号" placeholder="工单号/交易流水号" v-model.trim="orderNum">
      </div>
      <div>
        <el-select v-model="selectApplicant" placeholder="申请人">
          <el-option
            v-for="item in applicantList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectRechargeType" placeholder="充值类型">
          <el-option
            v-for="item in rechargeTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectPaymentType" placeholder="支付方式">
          <el-option
            v-for="item in paymentTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectRefusedApply" placeholder="拒绝申请">
          <el-option
            v-for="item in refusedApplyList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectHandlerList" placeholder="处理人">
          <el-option
            v-for="item in handlerList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w70">申请时间：</div>
      <div>
        <el-date-picker
          v-model.trim="startTime"
          :value="startTime"
          type="date"
          placeholder="开始时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      ~
      <div>
        <el-date-picker
          v-model.trim="endTime"
          :value="endTime"
          type="date"
          placeholder="结束时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <button class="btn_normal" @click="queryData()">查询</button>
    </div>
    <!--充值工单列表列表-->
    <div class="recharge_order_msg">
      <table class="table">
        <thead>
        <tr>
          <th>工单号</th>
          <th>申请人</th>
          <th>充值类型</th>
          <th>支付方式</th>
          <th>充入账号</th>
          <th>交易单号</th>
          <th>充值金额</th>
          <th>申请时间</th>
          <th>状态</th>
          <th>处理人</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.OrderNo}}</td>
          <td class="no_newline">{{item.CreaterName}}</td>
          <td class="no_newline">{{item.RechargeType | rechargetype}}</td>
          <td class="no_newline">{{item.PayType | paytype }}</td>
          <td class="text_left no_newline">
            <p v-if="item.PayType">{{item.PayType | paytype }}：</p>
            <p>{{item.Account}}</p>
          </td>
          <td>{{item.PayNo}}</td>
          <td>{{item.Amount}}元</td>
          <td>{{item.CreateTime | time}}</td>
          <td class="no_newline">{{item.OrderStatus | rechargeorderstatus}}</td>
          <td class="no_newline">{{item.CheckerName}}</td>
          <td>
            <a v-if="item.OrderStatus === 3" class="no_newline" title="删除" @click="ctrlBtn('del', item)">删除</a>
            <a v-if="item.OrderStatus === 3" class="no_newline" title="拒绝原因" @click="ctrlBtn('refuseReason', item)">拒绝原因</a>
            <a class="no_newline" title="日志" @click="ctrlBtn('log', item)">日志</a>
          </td>
        </tr>
        <!-- <tr>
          <td>假的CZGD20190305194228001</td>
          <td>张三</td>
          <td>手工充值</td>
          <td>支付宝</td>
          <td>
            <p>支付宝：</p>
            <p>15899999999@qq.com</p>
          </td>
          <td>20190306200040011100960005963258</td>
          <td>999.99元</td>
          <td>2019-03-05 19:42:28</td>
          <td>待审核</td>
          <td></td>
          <td>
            <a title="日志">日志</a>
          </td>
        </tr>
        <tr>
          <td>假的CZGD20190305194228001</td>
          <td>张三</td>
          <td>手工充值</td>
          <td>支付宝</td>
          <td>
            <p>支付宝：</p>
            <p>15899999999@qq.com</p>
          </td>
          <td>20190306200040011100960005963258</td>
          <td>999.99元</td>
          <td>2019-03-05 19:42:28</td>
          <td>拒绝申请</td>
          <td>平台管理员</td>
          <td>
            <a class="no_newline" title="删除" @click="ctrlBtn('del', 1)">删除</a>
            <a class="no_newline" title="拒绝原因" @click="ctrlBtn('refuseReason', 1)">拒绝原因</a>
            <a class="no_newline" title="日志" @click="ctrlBtn('log', 1)">日志</a>
          </td>
        </tr> -->
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="11">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <recharge-order-embed-msg v-if="isShow"
                              :title="dialogTitle"
                              :orderMsg="orderMsg"
                              :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></recharge-order-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import RechargeOrderEmbedMsg from './recharge-order-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'recharge-order',
    components: {RechargeOrderEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        orderMsg: '', // 工单信息
        list: [], // 工单列表
        orderNum: null, // 工单号
        applicantList: [], // 申请人列表
        selectApplicant: '', // 选择的申请人
        rechargeTypeList: [], // 充值类型下拉列表
        selectRechargeType: '', // 选择的充值类型
        paymentTypeList: [], // 支付方式下拉列表
        selectPaymentType: '', // 选择的支付方式
        refusedApplyList: [], // 拒绝申请下拉列表
        selectRefusedApply: '', // 选择的拒绝申请理由
        handlerList: [], // 处理人下拉列表
        selectHandlerList: '', // 选择的处理人
        startTime: new Date(new Date() - 1000 * 60 * 60 * 24 * 30), // 开始时间
        endTime: new Date(), // 结束时间
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsg = msg;
        switch (type) {
          case 'log':
            this.dialogTitle = '操作日志';
            break;
          case 'refuseReason':
            this.dialogTitle = '拒绝原因';
            break;
          case 'del':
            this.dialogTitle = '删除工单';
            break;
        }
      },

      // 获取当前时间 + 30天前时间
      getTime() {
        const nowDate = new Date();
        this.startTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
        this.endTime = new Date();
      },

      // 加载分销商充值工单申请人下拉信息
      getRechargeWorkOrderCreater() {
        this.$axios.get(this.Global.getRechargeWorkOrderCreater).then((res) => {
          if (!res.data.errorMsg.length) {
            this.applicantList = res.data.resData;
            this.applicantList.splice(0, 0, {id: '', text: '申请人'});
            this.selectApplicant = '';
          } else {
            this.applicantList = [];
            this.selectApplicant = res.data.errorMsg;
          }
        });
      },

      // 加载分销商充值工单处理人下拉信息
      getRechargeWorkOrderChecker() {
        this.$axios.get(this.Global.getRechargeWorkOrderChecker).then((res) => {
          if (!res.data.errorMsg.length) {
            this.handlerList = res.data.resData;
            this.handlerList.splice(0, 0, {id: '', text: '处理人'});
            this.selectHandlerList = '';
          } else {
            this.handlerList = [];
            this.selectHandlerList = res.data.errorMsg;
          }
        });
      },

      // 加载分销商充值工单充值类型下拉数据
      getRechargeWorkOrderType() {
        this.$axios.get(this.Global.getRechargeWorkOrderType).then((res) => {
          if (!res.data.errorMsg.length) {
            this.rechargeTypeList = res.data.resData;
            this.rechargeTypeList.splice(0, 0, {id: '', text: '充值类型'});
            this.selectRechargeType = '';
          } else {
            this.rechargeTypeList = [];
            this.selectRechargeType = res.data.errorMsg;
          }
        });
      },

      // 加载分销商充值工单支付方式下拉数据
      getRechargeWorkOrderPayType() {
        this.$axios.get(this.Global.getRechargeWorkOrderPayType).then((res) => {
          if (!res.data.errorMsg.length) {
            this.paymentTypeList = res.data.resData;
            this.paymentTypeList.splice(0, 0, {id: '', text: '支付方式'});
            this.selectPaymentType = '';
          } else {
            this.paymentTypeList = [];
            this.selectPaymentType = res.data.errorMsg;
          }
        });
      },

      // 加载分销商充值工单状态下拉数据
      getRechargeWorkOrderStatus() {
        this.$axios.get(this.Global.getRechargeWorkOrderStatus).then((res) => {
          if (!res.data.errorMsg.length) {
            this.refusedApplyList = res.data.resData;
            this.refusedApplyList.splice(0, 0, {id: '', text: '工单状态'});
            if (!this.selectRefusedApply) {
              this.selectRefusedApply = '';
            }
          } else {
            this.refusedApplyList = [];
            this.selectRefusedApply = res.data.errorMsg;
          }
        });
      },

      // 查询数据
      queryData() {
        if (!this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请时间';
          return;
        } else if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择结束时间';
          return;
        } else if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择开始时间';
          return;
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
          return;
        }
        this.currentPage = 1;
        this.getRechargeWorkOrderList();
      },

      // 获取充值工单分页数据
      getRechargeWorkOrderList() {
        this.isLoading = true;
        const params = {
          RechargeType: this.selectRechargeType,
          PayType: this.selectPaymentType,
          CreaterId: this.selectApplicant,
          CheckerId: this.selectHandlerList,
          IdOrName: this.orderNum,
          Status: this.selectRefusedApply,
          BeginCreateTime: this.Global.timeFormatStart(this.startTime),
          EndCreateTime: this.Global.timeFormatEnd(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getRechargeWorkOrderList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.list = [];
                self.listErr = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (this.dialogShowType === 'del' && e.handleType) {
          this.currentPage = 1;
          this.getRechargeWorkOrderList();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getRechargeWorkOrderList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getRechargeWorkOrderList();
      }
    },
    created() {
      this.getTime();
      if (this.$route.query['status']) {
        // console.log(9999999);
        // this.getRechargeWorkOrderStatus();
        this.selectRefusedApply = this.$route.query['status'];
      }
      this.getRechargeWorkOrderCreater();
      this.getRechargeWorkOrderChecker();
      this.getRechargeWorkOrderType();
      this.getRechargeWorkOrderPayType();
      this.getRechargeWorkOrderStatus();
      this.getRechargeWorkOrderList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.getTime();
        this.isShow = false;
        this.orderNum = null;
        // this.startTime = null;
        // this.endTime = null;
        this.currentPage = null;
        this.currentPage = 1;
        this.pageSize = 10;
        this.getRechargeWorkOrderCreater();
        this.getRechargeWorkOrderChecker();
        this.getRechargeWorkOrderType();
        this.getRechargeWorkOrderPayType();
        this.getRechargeWorkOrderStatus();
        this.getRechargeWorkOrderList();
      } else {
        if (this.$route.query['status']) {
          // this.getRechargeWorkOrderStatus();
          this.getTime();
          this.isShow = false;
          this.orderNum = null;
          // this.startTime = null;
          // this.endTime = null;
          this.currentPage = null;
          this.currentPage = 1;
          this.pageSize = 10;
          this.selectRefusedApply = this.$route.query['status'];
          this.getRechargeWorkOrderList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .recharge_order {

    .recharge_order_top {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      margin-top: 10px;
      margin-bottom: 10px;

      & > div {
        display: inline-block;
        width: 9%;

        &.w_percent15 {
          width: 15%;
        }

        &.w70 {
          width: 70px;
        }
      }
    }

    .recharge_order_msg {
      /*height: calc(100% - 99px);*/
      height: calc(100% - 53px);
      padding: 0 5px;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/recharge-order.vue